const sk = {
    common: {
        history: "historická verzia"
    }
};
export default sk;



// WEBPACK FOOTER //
// ./src/i18n/langs/sk.js